import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * We cannot do the authorizations since callback stuff. but we can keep the url on 1 spot:
 */
@Injectable({
    providedIn: 'root'
})
export class MsgraphApiClient {

    public clientid: string = "1a50f065-34cc-4cb7-9238-c238496d639f";

    public createUrlForUser(userGuid: string): string {
        let url = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=" + this.clientid + "&scope=offline_access%20Files.ReadWrite.All&response_type=code&redirect_uri=" +
            environment.apiUrl + "/api/external/msgraph/authenticatev2&state=" + userGuid;
        return url;
    }
    public createUrlForOrganisation(organisationGuid: string, redirectUrl: string): string {
        let url = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=" + this.clientid + "&scope=offline_access%20Files.ReadWrite.All&response_type=code&redirect_uri=" +
            redirectUrl + "&state=" + organisationGuid;
        return url;
    }


}
